<template>
  <div>
    <b-overlay :show="loading" rounded="sm">
      <p v-if="this.appuntamento.confirmed" class="m-0 font-weight-bold text-primary">Confermato</p>
      <!-- <span
        v-else
        class="bg-primary text-white px-2 py-1 mb-2 point font-weight-bold rounded"
        @click="conferma"
      >Conferma</span>-->
      <b-button
        variant="orange text-white px-2 py-1 my-1 point font-weight-bold rounded"
        size="sm"
        v-else
        @click="conferma"
      >Conferma</b-button>
    </b-overlay>
  </div>
</template>
<script>
export default {
  name: "confirm-btn",
  props: ["appuntamento", "evento"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    conferma() {
      this.loading = true;
      var url =
        process.env.VUE_APP_VERSION + "consulto/" + this.appuntamento.hashid;
      this.$axios
        .put(url)
        .then(res => {
          // console.log(res);
          this.appuntamento.confirmed = true;
          this.loading = false;
          if (this.evento) {
            this.$emit("confermato", this.appuntamento.confirmed);
          }
        })
        .catch(err => {
          console.log(err);
          if (err && err.response.status == 403) {
            this.appuntamento.confirmed = false;
            this.loading = false;
          }
        });
    }
  }
};
</script>
